module.exports = __webpack_public_path__ + "static/media/groupAdmin.d5181b91.png";